var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useSelector } from 'react-redux';
import TopNavigation from '../TopNavigation';
import { useNavigate } from 'react-router-dom';
import { Container, Fields, OptionButton } from './styles';
import Service from '../../services/Service';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from '../../i18n';
var StepConfirmation = function (_a) {
    var step = _a.step;
    var navigate = useNavigate();
    var t = useTranslation().t;
    var _b = React.useState(false), finalized = _b[0], setFinalized = _b[1];
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var _c = useSelector(function (state) { return state.form; }), form = _c.form, formInfo = _c.formInfo;
    var finalize = function () {
        var params = {
            onboardingForm: {
                countSteps: form.countSteps,
                steps: [__assign({}, form.steps[step])],
            },
            tokenOnboarding: (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '',
        };
        Service.saveStep(params);
    };
    React.useEffect(function () {
        if (!finalized) {
            setFinalized(true);
            finalize();
        }
    }, []);
    return (React.createElement(Container, null,
        React.createElement(ToastContainer, null),
        React.createElement(TopNavigation, { showLogo: true, showBackButton: form.steps[step].goBack, title: form.steps[step].showStepName ? form.steps[step].stepName : '', headerTransparent: form.steps[step].headerTransparent, headerPadding: theme.logoPosition !== "header" ? 1 : 0 }),
        React.createElement(Fields, { style: { paddingBottom: 10 } }, t('confirmation.success', { token: (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '' })),
        React.createElement(Fields, { style: { paddingBottom: 50 } },
            React.createElement(OptionButton, { onClick: function () { return navigate('/'); } }, t('confirmation.restart')))));
};
export default StepConfirmation;
